@if (component) {
<div class="flex flex-justify-center">
    <div class="c-11-m c-11-s flex flex-column-s"
         [ngClass]="component.images.length === 1 ? 'c-12 flex-justify-center' : 'c-8 m-r-0 flex-space-between' ">
        @for (item of component.images; track $index; let isFirst = $first) {
        <div class="left c-6 c-12-s"
             [ngClass]="{ 'm-r-0': !isFirst && component.images.length > 1,
                              'c-5-x c-10-m': component.images.length === 1,
                              'm-b-10-s': isFirst }">
            <div class="ratio-3-4 w-12">
                <img [image]="item.image"
                     class="rf">
            </div>
            <div class="p2 col-12 m-t-2"
                 *iCms="'caption' of item; content: 'html'"></div>
        </div>
        }
    </div>
</div>
}
